import React from "react";

export default function SearchPEM() {
  return (
    <div>
      <h1>finding best pem</h1>
    </div>
  );
}
